<template>
  <div class="_display:inline-flex">
    <a
      :href="url"
      class="flex items-center justify-center p-2 border border-transparent rounded-md shadow-sm text-white bg-[#4285F4] hover:bg-[#3367D6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 _transition:all _transition-duration:200"
      :aria-label="ariaLabel"
      :class="{ '_width:14 _height:12 _padding-x:2': !label, '_py:2 _px:4': label }"
      :title="label || ariaLabel">
      <svg class="w-5 h-5" :class="{ 'mr-2': label }" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
      </svg>
      <span v-if="label" class="text-sm font-medium">{{ label }}</span>
    </a>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    label: {
      type: String,
      default: 'Continue with Google',
    },
    role: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
  })

  const url = computed(() => {
    const baseUrl = route('auth.google')
    return props.role ? `${baseUrl}?user_role=${props.role}` : baseUrl
  })

  const ariaLabel = computed(() => {
    if (props.role === 'student-user') {
      return 'Sign up with Google as Student'
    } else if (props.role === 'trial-user') {
      return 'Sign up with Google as Course Creator'
    }
    return 'Continue with Google'
  })
</script>
